import axios from "axios";

// Production can be served from a custom domain: the API then lives on the same origin (/api is routed
// by the ingress), so prefer window.location.origin whenever it differs from the build-time URL.
const configured = process.env.REACT_APP_BACKEND_URL;
export const apiOrigin = (() => {
  try {
    const built = new URL(configured);
    const here = window.location;
    if (here.protocol === "https:" && here.host !== built.host && here.hostname !== "localhost") return here.origin;
  } catch {
    /* fall through to the configured URL */
  }
  return configured;
})();

export const api = axios.create({
  baseURL: `${apiOrigin}/api`,
  withCredentials: true,
});

// Display key for TV / signage screens (Videri etc.) that cannot complete a Google sign-in: the admin creates a
// link `/?display=<key>`; the key is kept in memory + localStorage and sent as a header on every API call.
// The URL is left untouched so a kiosk browser that drops storage still works after the periodic reload.
const DISPLAY_STORAGE = "fora_display_key";
export const DISPLAY_HEADER = "X-Display-Key";
let displayKey = null;
try {
  displayKey = new URLSearchParams(window.location.search).get("display") || null;
  if (displayKey) localStorage.setItem(DISPLAY_STORAGE, displayKey);
  else displayKey = localStorage.getItem(DISPLAY_STORAGE);
} catch {
  /* storage unavailable (kiosk / private mode) – the key from the URL still works in memory */
}
export const hasDisplayKey = () => !!displayKey;
export function clearDisplayKey() {
  displayKey = null;
  try {
    localStorage.removeItem(DISPLAY_STORAGE);
  } catch {
    /* ignore */
  }
}
api.interceptors.request.use((cfg) => {
  if (displayKey) cfg.headers[DISPLAY_HEADER] = displayKey;
  return cfg;
});

export function errorText(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return e?.message || "Something went wrong";
}
